/* eslint-disable eol-last */
// java 涂工接口
import request from '@/utils/request'
// 运单管理
export function selectoutbillorder(query) {
  return request({
    url: '/api/out/order/selectoutbillorder',
    method: 'get',
    params: query
  })
}
export function exportproductsbatch(query) {
  return request({
    url: '/api/out/order/exportproductsbatch',
    method: 'get',
    params: query
  })
}
// 新建出库单
export function insertoutbillorder(data) {
  return request({
    url: '/api/out/order/insertoutbillorder',
    method: 'post',
    data
  })
}
export function insertoutbillorderproduct(data) {
  return request({
    url: '/api/out/order/insertoutbillorderproduct',
    method: 'post',
    data
  })
}
// 出库单下载接口
export function donloadoutbillorder(query) {
  return request({
    url: '/api/out/order/donloadoutbillorder',
    method: 'get',
    params: query
  })
}
/** PDA 排运单 Excel（.xlsx，对齐 PDA OutOpt 导入模板） */
export function exportPdaFreightExcel(query) {
  return request({
    url: '/api/out/order/ty/exportFreightExcel',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}
// 修改出库单
export function updateoutbillorder(data) {
  return request({
    url: '/api/out/order/updateoutbillorder',
    method: 'post',
    data
  })
}
// 删除出库单
export function deleteoutbillorder(query) {
  return request({
    url: '/api/out/order/deleteoutbillorder',
    method: 'get',
    params: query
  })
}
// 完成出库（田园：须带运单号，会收集旧云待推）
export function updateoutstatus(query) {
  return request({
    url: '/api/out/order/ty/updateoutstatus',
    method: 'get',
    params: query
  })
}
// 退货查询
export function queryrejected(query) {
  return request({
    url: '/api/out/rejectedlog/queryrejected',
    method: 'get',
    params: query
  })
}
// 换货查询
export function selectoutbillorderbarter(query) {
  return request({
    url: '/api/out/order/selectoutbillorderbarter',
    method: 'get',
    params: query
  })
}
// 解除运单关联
export function queryremove(query) {
  return request({
    url: '/api/out/rejectedlog/queryremove',
    method: 'get',
    params: query
  })
}
// 箱码查询
export function selectoutbillorderqrcode(data) {
  return request({
    url: '/api/out/order/outCodes',
    method: 'post',
    data
  })
}
// 年份起始
export function basicconfig(query) {
  return request({
    url: '/api/out/basic/config',
    method: 'get',
    params: query
  })
}
// 批次流向
export function findDirection(data) {
  return request({
    url: '/api/out/outbillorderproductsbatch/findDirection',
    method: 'post',
    data
  })
}
// 消费者扫码
export function qrcodecount(query) {
  return request({
    url: '/api/out/qrcode/qrcodecount',
    method: 'get',
    params: query
  })
}
// 消费者查询真伪页
export function queryconsumer(query) {
  return request({
    url: '/api/out/consume/queryconsumer',
    method: 'get',
    params: query
  })
}
// 稽查流水报表
export function selectins(data) {
  return request({
    url: '/api/out/msc/selectins',
    method: 'post',
    data
  })
}

// 稽查箱码
export function qrcodescaninspectleveltwolist(data) {
  return request({
    url: '/api/out/qrcodescaninspectleveltwo/list',
    method: 'post',
    data
  })
}
// 最终判断是否串货
export function qrcodescaninspectleveltwoupdate(data) {
  return request({
    url: '/api/out/qrcodescaninspectleveltwo/update',
    method: 'post',
    data
  })
}
// 预警清单http://192.168.4.21:8108/api/out/consume/queryconsumerwarning
export function queryconsumerwarning(query) {
  return request({
    url: '/api/out/consume/queryconsumerwarning',
    method: 'get',
    params: query
  })
}
// 取证记录
export function selectcorrect(query) {
  return request({
    url: '/api/out/msc/selectcorrect',
    method: 'get',
    params: query
  })
}
export function selectimage(query) { // 查图片
  return request({
    url: '/api/out/msc/selectimage',
    method: 'get',
    params: query
  })
}
export function findconfig(query) { // 查询配置预警参数
  return request({
    url: '/api/out/consume/findconfig',
    method: 'get',
    params: query
  })
}
export function updateconfig(query) { // 修改预警参数
  return request({
    url: '/api/out/consume/updateconfig',
    method: 'get',
    params: query
  })
}
export function findallbyqrcode(query) { // 产品信息查询
  return request({
    url: '/api/out/consume/findallbyqrcode',
    method: 'get',
    params: query
  })
}
export function flowinfo(query) { // 产品信息查询
  return request({
    url: '/api/out/flow/info',
    method: 'get',
    params: query
  })
}
export function findqrcodenotinworkorder(data) { // 交货单查询
  return request({
    url: '/api/out/pda/findqrcodenotinworkorder',
    method: 'post',
    data
  })
}
export function listtoken(query) { // 交货单查询
  return request({
    url: '/api/out/logic/list',
    method: 'get',
    params: query
  })
}

// 经销商签收
export function signorderlist(data) { // 签收记录
  return request({
    url: '/api/out/dealerSignOrder/list',
    method: 'post',
    data
  })
}
export function signorderproductslist(data) { // 签收产品记录
  return request({
    url: '/api/out/dealerSignOrderProducts/list',
    method: 'post',
    data
  })
}
export function signorderproductscodelist(data) { // 签收产品码记录
  return request({
    url: '/api/out/dealerSignOrderProductsCode/list',
    method: 'post',
    data
  })
}
export function signimageurllist(data) { // 图片列表
  return request({
    url: '/api/out/signimageurl/list',
    method: 'post',
    data
  })
}

export function signqrcodescanloglist(data) { // 异常记录
  return request({
    url: '/api/out/signqrcodescanlog/list',
    method: 'post',
    data
  })
}
export function outbillorderproductsbatchlist(data) { // 运单批次产品表
  return request({
    url: '/api/out/outbillorderproductsbatch/list',
    method: 'post',
    data
  })
}

// 退货日志查询
// export function goodsorders(data) { // 单据
//   return request({
//     url: '/api/out/return/goods/orders',
//     method: 'post',
//     data
//   })
// }
export function goodsproducts(data) { // 产品
  return request({
    url: '/api/out/return/goods/products',
    method: 'post',
    data
  })
}
export function goodscodes(data) { // 码
  return request({
    url: '/api/out/return/goods/codes',
    method: 'post',
    data
  })
}

// 经销商退货到工厂
export function goodsorders(data) { // 退货单
  return request({
    url: '/api/out/return/goods/orders',
    method: 'post',
    data
  })
}
export function returnorderProducts(data) { // 产品
  return request({
    url: '/api/out/return/goods/orderProducts',
    method: 'post',
    data
  })
}
export function returngoodscodes(data) { // 码
  return request({
    url: '/api/out/return/goods/codes',
    method: 'post',
    data
  })
}
export function merchantsChannelsAreaslist(data) { // 码
  return request({
    url: '/api/org/merchantsChannelsAreas/list',
    method: 'post',
    data
  })
}